import { joinParts } from './utils'

export const vault = {
  check: () => joinParts('vault', 'check'),
  request: () => joinParts('vault', 'request'),
  checkBulk: () => joinParts('vault', 'bulk', 'check'),
  requestBulk: () => joinParts('vault', 'bulk', 'request'),
}
